<template>
  <div>
    <ca-heading text="Horários/Turnos" />
    <ca-row>
      <ca-col>
        <ca-button theme="primary" @click="onNew">Novo Horário/Turno</ca-button>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col>
        <ca-async-content-wrapper
          :key="wrapperKey"
          :on-fetch="getWorkShifts"
          :on-fetch-success="setWorkShifts">
          <ca-table>
            <ca-tr slot="header">
              <ca-th>Código</ca-th>
              <ca-th size="8">Jornada de trabalho</ca-th>
              <ca-th size="4">Tipo de intervalo</ca-th>
              <ca-th size="8">Intervalo</ca-th>
              <ca-th></ca-th>
            </ca-tr>
            <ca-tr
              v-for="(workShift, index) in workShifts.content"
              :key="index"
              @click="onView(workShift.id)">
              <ca-td>
                {{ workShift.code }}
              </ca-td>
              <ca-td>
                {{ `${workShift.checkInTime} a ${workShift.checkOutTime}` }}
              </ca-td>
              <ca-td>
                {{ workShift.breakType.description }}
              </ca-td>
              <ca-td v-if="workShift.breakType.name === 'F'">
                {{ `${workShift.startOfBreak} a ${workShift.endOfBreak}` }}
              </ca-td>
              <ca-td v-if="workShift.breakType.name === 'V'">
                {{ workShift.breakDuration }}
              </ca-td>
              <ca-td v-if="workShift.breakType.name === 'S'"> </ca-td>
              <ca-td>
                <ca-button
                  class="ca-u-min-margin-right"
                  size="small"
                  @click.stop="onEdit(workShift.id)">
                  Editar
                </ca-button>
                <ca-button
                  size="small"
                  @click.stop="onDelete(index, workShift.id)">
                  Excluir
                </ca-button>
              </ca-td>
            </ca-tr>
          </ca-table>
        </ca-async-content-wrapper>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col class="ca-u-text-center">
        <ca-pagination
          v-if="workShifts.totalPages > 1"
          v-model="currentPage"
          :total-pages="workShifts.totalPages"
          class="ca-u-flex ca-u-align-items--center ca-u-justify-content--center">
        </ca-pagination>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import { isEsocialDisabledStatus } from 'accountant/esocial/esocialService';
import { ESOCIAL_DISABLED_STATUS } from 'accountant/esocial/contants';
import {
  DELETE_TITLE, DELETE_MESSAGE, DELETE_CONFIRM_TEXT, DELETE_SUCCESS_MESSAGE,
} from './constants';
import { getWorkShifts, deleteWorkShift } from './workShiftService';

export default {
  name: 'WorkShiftsPage',
  data() {
    return {
      wrapperKey: 0,
      currentPage: 0,
      workShifts: {},
      ESOCIAL_DISABLED_STATUS,
    };
  },
  computed: {
    misc() {
      return this.$store.state.misc;
    },
  },
  watch: {
    currentPage() {
      this.updateList();
    },
  },
  created() {
    this.$store.dispatch('misc/getEsocialStatus');
  },
  methods: {
    isEsocialDisabledStatus,
    getWorkShifts() {
      return getWorkShifts({ page: this.currentPage });
    },
    async setWorkShifts(workShifts) {
      this.workShifts = workShifts;
    },
    updateList() {
      this.wrapperKey++;
    },
    onNew() {
      this.$router.push({ name: 'NewWorkShift' });
    },
    onView(id) {
      this.$router.push({ name: 'ViewWorkShift', params: { id } });
    },
    onEdit(id) {
      this.$router.push({ name: 'EditWorkShift', params: { id } });
    },
    onDelete(index, workShiftId) {
      this.$caConfirm({
        title: DELETE_TITLE,
        message: DELETE_MESSAGE,
        confirmButtonText: DELETE_CONFIRM_TEXT,
        onConfirm: () => {
          deleteWorkShift(workShiftId)
            .then(() => {
              this.$delete(this.workShifts.content, index);
              this.$toaster.success(DELETE_SUCCESS_MESSAGE);
            })
            .catch(e => {
              this.$toaster[e.status](e.message);
            });
        },
      });
    },
  },
};
</script>
